import { TextInput, required } from "react-admin";
import { Grid } from "@mui/material";

const SaveForm = () => {
  return (
    <Grid
      container
      spacing={2}
    >
      <Grid
        item
        xs={12}
        md={6}
      >
        <TextInput
          label="Име"
          source="nameBg"
          validate={required()}
        />
      </Grid>
    </Grid>
  );
};

export default SaveForm;
